export type { Frame } from './frame';
export type * from './types';

import type { TFrameOptions } from './types';
import { Frame } from './frame';

/**
 * a transport facility for remote views (crates, micros, and hosting) between applications
 */
export class Portal {
  /**
   * @deprecated use startup
   * create a frame
   */
  createFrame(settings?: Partial<TFrameOptions>) {
    return new Frame(settings);
  }

  /**
   * @deprecated use startup
   * create a frame and immediately invoke it
   */
  invokeFrame(settings?: Partial<TFrameOptions>) {
    return this.createFrame(settings).startup();
  }

  /**
   * create a frame
   */
  create(settings?: Partial<TFrameOptions>) {
    return new Frame(settings);
  }

  /**
   * create a frame and immediately invoke it
   */
  startup(settings?: Partial<TFrameOptions>) {
    return new Frame(settings).startup();
  }

  /**
   * load a run plan to undo the startup affect
   */
  shutdown(settings?: Partial<TFrameOptions>) {
    return new Frame(settings).shutdown();
  }
}

export default new Portal();
